import React, {Component} from "react";
import PropTypes from "prop-types";
import {ICEBREAKER} from "../constants/dimensions";

export default class Icebreaker extends Component {
    static propTypes = {
        delay: PropTypes.number,
        text: PropTypes.string,
        styles: PropTypes.object,
        buttonStyle: PropTypes.object,
    };

    static defaultProps = {
        delay: 0,
        styles: {
            borderColor: '#ffffff',
        },
    };

    state = {
        showIcebreaker: false,
    };

    componentDidMount() {
        this.waitForIcebreaker();
    }

    waitForIcebreaker() {
        setTimeout(() => {
            this.setState({
                showIcebreaker: true,
            });
        }, this.props.delay);
    }

    render() {
        const { text, styles, buttonStyle } = this.props;
        let initialStyles = {
            backgroundColor: styles.backgroundColor,
            color: styles.textColor,
            width: styles.width || ICEBREAKER.DEFAULT_WIDTH,
            height: styles.height || ICEBREAKER.DEFAULT_HEIGHT,
            right: buttonStyle.width + 15 + 'px',
        };

        if (styles.borderWidth) {
            initialStyles = {
                ...initialStyles,
                borderWidth: styles.borderWidth,
                borderColor: styles.borderColor,
                borderStyle: 'solid',
            };
        }

        return (
            <div className={`cb-icebreaker cb-icebreaker-${this.state.showIcebreaker ? 'shown' : 'hidden'}`} style={initialStyles}>
                {text}
            </div>
        );
    }
}
